import { useApp } from '../../AppContext';
import React, { useState, useMemo, useEffect, useCallback } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import { getDiscountedPrice } from "../../Utils";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { updateBook, moveBook } from "./UpdateBook";
import AppDataTable from '../../components/AppDataTable';
import { fetchBooks } from '../../apiCalls';
import { showConfirm } from '../../ConfirmBox';

export default function Books() {
    const { books, setBooks, oldBooks, setOldBooks } = useApp();
    const loadBooksData = async () => {
        try {
            const booksData = await fetchBooks();
            console.log(booksData)
            setBooks(booksData);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        if (books.length === 0) {
            loadBooksData();
        }
        console.log("books", books)
    }, []);


    const navigate = useNavigate();
    const [search, setSearch] = useState("");

    const handleView = (row) => {
        navigate(`/view-book/${row.book_id}`);
    };

    const handleEdit = (row) => {
        navigate(`/update-book/${row.book_id}`);
    };

    const handleDelete = async (row) => {
        showConfirm(
            "Confirm Delete",
            `Are you sure you want to delete "${row.book_name}"? This will move it to the deleted books list.`,
            async () => {
                try {

                    const response = await updateBook(
                        { status: "DISABLED" },
                        row.book_id
                    );

                    if (response?.status) {
                        moveBook(
                            row.book_id,
                            setBooks,
                            setOldBooks,
                            row,
                            "DISABLED"
                        );
                    }
                } catch (error) {
                    console.error("Delete failed:", error);
                }
            }
        );
    };


    // 🔥 Filtered Data
    const filteredData = useMemo(() => {
        return books.filter((book) =>
            book.book_name.toLowerCase().includes(search.toLowerCase()) ||
            book.category_name.toLowerCase().includes(search.toLowerCase())
        );
    }, [books, search]);

    const columns = [
        {
            name: "Book Title",
            selector: row => row.book_name,
            sortable: true,
        },
        {
            name: "Category",
            selector: row => row.category_name,
            sortable: true,
        },
        {
            name: "MRP",
            selector: row => `₹ ${row.mrp}`,
            sortable: true,
        },
        {
            name: "Discount %",
            selector: row => row.discount_percent + "%",
            sortable: true,
        },
        {
            name: "Discounted Price",
            selector: row => `₹ ${getDiscountedPrice(row.mrp, row.discount_percent)}`,
            sortable: true,
        },
        {
            name: "Action",
            width: "120px",
            cell: (row) => (
                <div className="d-flex gap-3 fs-5">
                    <i
                        className="bi bi-eye text-info"
                        data-tooltip-id="viewTooltip"
                        data-tooltip-content="View Book"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleView(row)}
                    ></i>

                    <i
                        className="bi bi-pencil text-warning"
                        data-tooltip-id="editTooltip"
                        data-tooltip-content="Edit Book"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleEdit(row)}
                    ></i>

                    <i
                        className="bi bi-trash text-danger"
                        data-tooltip-id="deleteTooltip"
                        data-tooltip-content="Delete Book"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDelete(row)}
                    ></i>
                </div>
            ),
            ignoreRowClick: true,
        }
    ];
    return (
        <>
            <div className='page-title-container'>
                <h2>Our Books <span>List of all our books | View, Edit or Delete the books</span></h2>
                <button className='btn btn-secondary btn-sm save-btn' onClick={() => navigate("/add-book")}>Add Books</button>
            </div>
            <div className="table-responsive">
                <AppDataTable
                    columns={columns}
                    data={filteredData}
                />
            </div>

            <Tooltip id="viewTooltip" />
            <Tooltip id="editTooltip" />
            <Tooltip id="deleteTooltip" />
        </>
    )
}
